import { render, staticRenderFns } from "./LpuMedalCard.vue?vue&type=template&id=7c2548d6&scoped=true&"
import script from "./LpuMedalCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuMedalCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuMedalCard.vue?vue&type=style&index=0&id=7c2548d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2548d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2548d6')) {
      api.createRecord('7c2548d6', component.options)
    } else {
      api.reload('7c2548d6', component.options)
    }
    module.hot.accept("./LpuMedalCard.vue?vue&type=template&id=7c2548d6&scoped=true&", function () {
      api.rerender('7c2548d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuMedals/components/LpuMedalCard.vue"
export default component.exports